export const missionTypes: {
  link: 'LINK';
  channel: 'CHANNEL';
  custom: 'CUSTOM';
  quest: 'QUEST';
} = {
  link: 'LINK',
  channel: 'CHANNEL',
  custom: 'CUSTOM',
  quest: 'QUEST',
};

export const missionTabs: {
  all: 'all';
  oneTime: 'oneTime';
  // progressive: 'progressive';
  repetitive: 'repetitive';
} = {
  all: 'all',
  oneTime: 'oneTime',
  // progressive: 'progressive',
  repetitive: 'repetitive',
};

export const missionDuration: {
  daily: 'DAILY';
  permanent: 'PERMANENT';
} = {
  daily: 'DAILY',
  permanent: 'PERMANENT',
};

export const mapMissionTabs = {
  [missionDuration.permanent]: missionTabs.oneTime,
  [missionDuration.daily]: missionTabs.repetitive,
};

export const missionVisibility: {
  app: 'APP';
  wallet: 'WALLET';
} = {
  app: 'APP',
  wallet: 'WALLET',
};
